var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('guide-visual', _vm._b({}, 'guide-visual', _vm.visual, false)), _c('section', [_c('v-card', {
    staticClass: "py-60 py-lg-120",
    attrs: {
      "img": "/images/guide/legacy/legacy-introduction-bg.jpg",
      "tile": "",
      "flat": "",
      "color": "#085848"
    }
  }, [_c('v-container', [_c('p', {
    staticClass: "tit tit--sm font-size-lg-28 font--serif font-weight-medium text-center legacy-accent"
  }, [_c('strong', [_vm._v("The With-CAN")]), _vm._v("(위드캔 레거시 클럽)은 "), _c('br', {
    staticClass: "d-sm-none"
  }), _vm._v(" 귀한 유산을 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 사회에 영원히 남기며, 다음 세대와 공동체의 희망을 실현하는 사람들의 모임입니다. ")])])], 1)], 1), _c('div', {
    staticClass: "client-content-wrap grey-fa"
  }, [_c('scrolldown-tail'), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("유산기부 종류")])]), _c('v-row', {
    staticClass: "row--xs"
  }, _vm._l(_vm.types, function (type, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "type-card",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "justify-center pt-52"
    }, [_c('v-img', {
      attrs: {
        "src": type.icon,
        "max-width": "60",
        "alt": ""
      }
    })], 1), _c('v-card-text', {
      staticClass: "pb-52"
    }, [_c('div', {
      staticClass: "tit tit--sm legacy-accent text-center"
    }, [_vm._v(" " + _vm._s(type.name) + " ")])])], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("유산기부 절차")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/guide/legacy/process-list.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-row', {
    staticClass: "process-list row--lg"
  }, _vm._l(_vm.process, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      staticClass: "process-card",
      attrs: {
        "color": "#BD9E7A",
        "outlined": "",
        "flat": ""
      }
    }, [_c('v-row', {
      staticClass: "text-center"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "font--serif legacy-color font-weight-bold font-size-28"
    }, [_vm._v("0" + _vm._s(index + 1))]), _c('div', {
      staticClass: "client-title--xs font-weight-bold mt-16",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('v-img', {
      staticClass: "my-28 mx-auto",
      attrs: {
        "src": `/images/guide/legacy/process-${index + 1}.svg`,
        "max-width": "60"
      }
    }), _c('p', {
      staticClass: "page-text page-text--lg",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)], 1)], 1)], 1);
  }), 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "client-content-wrap respect-bg"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("후원자 예우")])]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.respect, function (item, index) {
    return [index < 2 ? _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "border-radius-16 h-100 mx-auto text-center",
      attrs: {
        "color": "#0C312C",
        "max-width": "384",
        "flat": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    }), _c('v-card-title', {
      staticClass: "justify-center pt-lg-40"
    }, [_c('div', {
      staticClass: "legacy-accent tit tit--sm"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('v-card-text', {
      staticClass: "pb-lg-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg white--text",
      domProps: {
        "innerHTML": _vm._s(item.texts)
      }
    })])], 1)], 1) : _vm._e()];
  })], 2), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.respect, function (item, index) {
    return [index >= 2 ? _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "border-radius-16 h-100 mx-auto text-center",
      attrs: {
        "color": "#0C312C",
        "max-width": "384",
        "flat": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    }), _c('v-card-title', {
      staticClass: "justify-center pt-lg-40"
    }, [_c('div', {
      staticClass: "legacy-accent tit tit--sm"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('v-card-text', {
      staticClass: "pb-lg-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg white--text",
      domProps: {
        "innerHTML": _vm._s(item.texts)
      }
    })])], 1)], 1) : _vm._e()];
  })], 2)], 1)], 1)]), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("자주 묻는 질문")])]), _c('faq-list', {
    attrs: {
      "items": _vm.faq,
      "legacy": ""
    }
  })], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }